import { useQuery } from '@tanstack/react-query';

import { usersKeys } from '@/domains/workflows/api/users';

export const useActiveUsersQuery = () => {
  // @ts-ignore
  const { data = [], isLoading } = useQuery({
    ...usersKeys.activeUsers({}),
  });

  return {
    data,
    isLoading,
  };
};
